export enum InternalEventType {
  /**
   * KEY_EXCHANGE is used between Communication layer and KeyExchange Layer
   */
  KEY_EXCHANGE = 'key_exchange',
}
